<script setup lang="ts">
import { TransitionPresets, useTransition } from '@vueuse/core'

interface IProps {
  sellValue: number
  buyValue: number
  currencyId: number
}

const props = defineProps<IProps>()

// Count up from zero once mounted, so SSR and hydration both render the initial zero
const isMounted = ref(false)
onMounted(() => (isMounted.value = true))

const transitionOptions = { duration: 500, easing: TransitionPresets.easeOutQuad }
const buy = useTransition(() => (isMounted.value ? props.buyValue : 0), transitionOptions)
const sell = useTransition(() => (isMounted.value ? props.sellValue : 0), transitionOptions)
</script>

<template>
  <strong class="whitespace-nowrap"
    >{{ useCurrencyFormat(buy, currencyId, false) }} /
    {{ useCurrencyFormat(sell, currencyId, false) }}</strong
  >
</template>
